<div class="flex row p-2 justify-between">
    <div class="text-lg font-medium tracking-tight leading-6 truncate">
        Edit Well Healthiness Status
    </div>
    <div>
        <mat-icon mat-dialog-close [svgIcon]="'heroicons_solid:x-mark'"></mat-icon>
    </div>
</div>
<hr class="my-0" />

<mat-dialog-content>
    <div class="flex justify-end mb-3" *ngIf="data.status">
        <div class="px-4 " [ngClass]="{
            'successBadge': data.status?.toLowerCase() === 'approved',
            'failedBadge': data.status?.toLowerCase() === 'rejected',
            'warningBadge': data.status?.toLowerCase() === 'ready to review'
        }">{{ data.status }}</div>
    </div>

    <div class="grid grid-cols-4 gap-4 border rounded p-4 ">
        <div class="flex flex-col">
            <div class="text-primary">Field Name</div>
            <div class="font-medium text-lg">{{ data.fieldLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div class="text-primary">Platform Name</div>
            <div class="font-medium text-lg">{{ data.platformLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div class="text-primary">Well Name</div>
            <div class="font-medium text-lg">{{ data.wellLongName }}</div>
        </div>
        <div class="flex flex-col">
            <div class="text-primary">Well String Name</div>
            <div class="font-medium text-lg">{{ data.stringLongName }}</div>
        </div>
    </div>

    <div class="mt-4">
        <form [formGroup]="form">
            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Well Healthiness</mat-label>
                <mat-select matNativeControl formControlName="isWellHealthy">
                    <mat-option [value]="true">Healthy</mat-option>
                    <mat-option [value]="false">Unhealthy</mat-option>
                </mat-select>
                <mat-error *ngIf="form.get('isWellHealthy')?.hasError('required')">Well Healthiness is
                    required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Risk Ranking</mat-label>
                <mat-select matNativeControl formControlName="scoringMatrix">
                    <ng-container *ngIf="form.get('isWellHealthy')?.value">
                        <mat-option [value]="0">Healthy no risk</mat-option>
                        <mat-option [value]="1">Healthy low risk</mat-option>
                        <mat-option [value]="2">Healthy medium risk</mat-option>
                    </ng-container>

                    <ng-container *ngIf="!form.get('isWellHealthy')?.value">
                        <mat-option [value]="3">Unhealthy high risk</mat-option>
                        <mat-option [value]="4">Unhealthy very high risk</mat-option>
                    </ng-container>
                </mat-select>
                <mat-error *ngIf="form.get('riskRanking')?.hasError('required')">Risk Ranking is required</mat-error>
            </mat-form-field>

            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Remarks</mat-label>
                <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="10"
                    formControlName="remarks"></textarea>
                <mat-error *ngIf="form.get('detailDesc')?.hasError('required')">Remarks is
                    required</mat-error>
            </mat-form-field>
        </form>
    </div>

    <div class="grid grid-cols-2 gap-4">
        <form [formGroup]="form">
            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Updated By</mat-label>
                <input type="text" matInput formControlName="updateBy" />
            </mat-form-field>
        </form>

        <form [formGroup]="form">
            <mat-form-field class="w-full custom-mat-form-field mx-2">
                <mat-label>Updated Date</mat-label>
                <input type="text" matInput formControlName="updateDate" />
            </mat-form-field>
        </form>

        <ng-container *ngIf="isApproved">
            <form [formGroup]="form">
                <mat-form-field class="w-full custom-mat-form-field mx-2">
                    <mat-label>Approved By</mat-label>
                    <input type="text" matInput formControlName="approvedBy" />
                </mat-form-field>
            </form>

            <form [formGroup]="form">
                <mat-form-field class="w-full custom-mat-form-field mx-2">
                    <mat-label>Approved Date</mat-label>
                    <input type="text" matInput formControlName="approvedDate" />
                </mat-form-field>
            </form>
        </ng-container>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-outline btn-error mx-1" mat-dialog-close>
        Cancel
    </button>
    <button *ngIf="!isReview" class="btn btn-primary mx-1" [disabled]="!form.valid"
        (click)="overrideWellHealthiness('Ready to Review')">Request Update</button>

    <button *ngIf="isReview" class="btn btn-error mx-1" (click)="overrideWellHealthiness('Rejected')">Reject</button>
    <button *ngIf="isReview" class="btn btn-success mx-1"
        (click)="overrideWellHealthiness('Approved')">Approve</button>

</mat-dialog-actions>

<ng-template #noRecords>
    <div class="p-8 sm:p-16 text-2xl sm:text-2xl font-semibold tracking-tight text-center">
        There are no records registered!
    </div>
</ng-template>